import { BiArrowBack } from 'react-icons/bi';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ProjectsEndpoints } from '../../Routes/api/Endpoints';
import LivraisonsDetails from '../../components/Client/projectsComponents/livraisonsComponents/LivraisonsDetails';
import { getFirstLetters } from '../../components/Utils/Variables/constantes';
import { selectData } from '../../redux/features/userSliceWithTokenValidation';
import { useGetDataQuery } from '../../services/auth-services/AuthService';
import { useFetchProjectsQuery } from '../../services/auth-services/TacheService';

const LivrablesPage = () => {
  const { id } = useParams()
  const user = useSelector(selectData)
  const location = useLocation()
  const navigate = useNavigate();

  const { data: projets } = useFetchProjectsQuery(
    ProjectsEndpoints.getProjects,
    {
      refetchOnMountOrArgChange: true,
      refetchOnFocus: true,
      skip: false,
    }
  );
  const filteredProjectsClient = projets ? projets?.filter((proj) => proj.user_id === user?.porteur_projet?.id)
    : [];
  const projet = filteredProjectsClient?.find((proj) => String(proj?.id) == id);


  const { data: livraisons, isLoading: loadingLivraison, refetch } = useGetDataQuery({ endpoint: ProjectsEndpoints.getLivraisonsCoach, projectId: id }, {
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true,
    skip: false
  });
  // console.log(location.pathname);

  return (
    <div className='p-6 '>
      <div className='w-3/4 max-lg:w-full'>
        {location.pathname.includes('livrables') && <div className='flex flex-wrap items-center gap-60 max-md:gap-5'>
          <button
            className="inline-flex gap-3 bg-transparent border-none"
            onClick={() => navigate(-1)}
          >
            <BiArrowBack size={20} className="" />
            <span className="font-inter font-medium text-sm">Retour</span>
          </button>
          <h4 className='font-inter text-lg text-black/80 font-bold'>Les livrables du projet {projet?.titre}</h4>
        </div>}
        <LivraisonsDetails
          name={projet && projet?.assigned_to_name}
          profileLetters={getFirstLetters}
          refecthData={refetch}
          livraisons={livraisons?.livraisons}
          isLoading={loadingLivraison}
          clientId={projet && projet?.user_id}
        />
      </div>
    </div>
  )
}

export default LivrablesPage
